
import {defineComponent} from "vue";

export default defineComponent({
  name: 'RiderProfilePage',
  components: {},
  setup: function () {
    return {}
  },
})
